import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import { API_URL } from '../../utils/config';
import request from '@acri-tools/react-tools/utils/request';
import { create_toast } from '@acri-tools/react-tools/utils/toasts';
import classNames from 'classnames';
import React,{Component} from 'react';
import { format_project_request_data } from '../../utils/projects';
import ProjectForm from '../ProjectForm/ProjectForm';

import './UpdateProject.css';

interface Props{
    project: any

    onUpdate?: Function
}
interface State{
    updating: boolean

    // updates 
    updates: any
}


export default class UpdateProject extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state = {
            updating: false,
            updates:{}
        }
    }

    componentDidUpdate(prevProps:any){
        if(this.props.project !== prevProps.project){
            this.setState({ updates: {} })
        }
    }
    
    render(){
        return (
            <div className="update-project">
                {/* <Optional>*Required</Optional> */}
                {/* <br/>
                <br/> */}

                <ProjectForm
                    updates={this.state.updates}
                    data={this.props.project}
                    onChange={(updates:any)=>{
                        this.setState({
                            updates: {
                                ...this.state.updates,
                                ...updates
                            }
                        });
                    }}
                />

                <br/>
                <br/>
                <div className="centered">
                    <div 
                        className={classNames({
                            "custom-button blue inline medium": true,
                            "disabled": this.state.updating
                        })}
                        onClick={this.update}
                    >
                        {
                            this.state.updating ? 
                            <Spinner height={15} white/>:
                            <><i className="fas fa-pen"/> UPDATE PROJECT</>
                        }

                    </div>
                </div>
            </div>
        );
    }


    update = async() =>{
        let { updates } = this.state;


        format_project_request_data(updates)

        this.setState({ updating: true })
        try{
            let res = await request(`${API_URL}/api/v1/projects/${this.props.project.id}`,{
                method:'put',
                data: updates
            })

            this.props.onUpdate?.();

            create_toast({ type: 'success', message: `Successfully updated project ${res.data.value.name}` })

            // console.log("this.state", this.state);
        }
        catch(e:any){
            axiosErrorHandler( e, { 
                functionName: 'update'
            })
            toast_request_error(e);
        }
        finally{
            this.setState({ updating: false })
        }
    }
};